export default __webpack_public_path__ + "static/media/mastercard.8d38a4e5.svg";